import styled from '@emotion/styled';

// eslint-disable-next-line import/prefer-default-export
export const CheckboxContainer = styled.div({
  paddingTop: '2.75rem',
  textAlign: 'left',
});
